import { api } from "@/api";
import {
  ContactDetails,
  ContactNote,
  QuickCreateContactOptions,
  QuickCreateContactRequest,
  QuickCreateContactResponse,
} from "@/types/domain";

export const fetchContactDetails = async (contactId: string): Promise<ContactDetails> => {
  const response = await api.get<ContactDetails>("/contact/details", {
    params: { contactId },
  });
  return response.data;
};

export const fetchContactNotes = async (
  contactId: string,
  companyId: string,
  page = 1,
  pageSize = 10
): Promise<{ items: ContactNote[]; totalCount: number }> => {
  const response = await api.get<{ items: ContactNote[]; totalCount: number }>("/contact/notes", {
    params: { contactId, companyId, page, pageSize },
  });
  return response.data;
};

export const createNote = async (dto: {
  contactId: string;
  companyId: string;
  subject: string;
  body: string;
}): Promise<{ id: string }> => {
  const response = await api.post<{ id: string }>("/note", dto);
  return response.data;
};

export const updateNote = async (id: string, dto: { subject: string; body: string }): Promise<void> => {
  await api.put(`/note/${id}`, dto);
};

export const deleteNote = async (id: string): Promise<void> => {
  await api.delete(`/note/${id}`);
};

export const patchContact = async (id: string, fields: Record<string, string | boolean | null>): Promise<void> => {
  await api.patch(`/contact/${id}`, fields);
};

export const patchContactUd = async (id: string, itemId: number, value: string): Promise<void> => {
  await api.patch(`/contact/${id}/ud`, { itemId, value });
};

export const deleteContact = async (id: string): Promise<void> => {
  await api.delete(`/contact/${id}`);
};

export const fetchQuickCreateContactOptions = async (
  customerId: string
): Promise<QuickCreateContactOptions> => {
  const response = await api.get<QuickCreateContactOptions>("/contact/quickcreate", {
    params: { customerId },
  });
  return response.data;
};

export const fetchContactFormOptions = async (
  customerId: string
): Promise<QuickCreateContactOptions> => {
  const response = await api.get<QuickCreateContactOptions>("/contact/form", {
    params: { customerId },
  });
  return response.data;
};

export const quickCreateContact = async (
  dto: QuickCreateContactRequest
): Promise<QuickCreateContactResponse> => {
  const response = await api.post<QuickCreateContactResponse>("/contact/quickcreate", dto);
  return response.data;
};

export const createContact = async (
  dto: QuickCreateContactRequest
): Promise<QuickCreateContactResponse> => {
  const response = await api.post<QuickCreateContactResponse>("/contact", dto);
  return response.data;
};
